import React, { Component } from 'react';
import './combobox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
//import SearchBar from '../SearchBar/searchbar';


class ComboBox extends Component {
  constructor(props) {
    super(props);
    // PROPS
    /*
      --config={isSelectable:true/false,columns:[
          {name:"",type:""},
          {name:"",type:""}
        ]}
        listItem=[{},{}];
        //  isSelectable = 
        // 
      --selectedItems  //callbackMethod
    */
      this.state = {
          selectedItemIds:[],
          columns:[],
          items:[],
          term:"",
          show:false,
      };

  }
  
  // INNER METHOD

  onTermUpdate = (clear,e) =>{
      this.setState({term:clear? "": e.target.value});
  }

  selectItem = (id) =>{
    var ids = [...this.state.selectedItemIds];
    
    if(!this.props.config.multiple){ 
      this.setState({selectedItemIds:[id],show:false});
      this.props.onSelectItem([id]);
    }else{
      if(ids.filter(i=>i === id).length >0){
        ids.splice(ids.indexOf(id),1);
      }else{
        ids.push(id);
      }
      this.props.onSelectItem([...new Set(ids)]);
      this.setState({selectedItemIds:[...new Set(ids)]});
    }

  }

  sortColumn = (id) =>{
    var columns = this.state.columns;
    var asc = true;
    columns = columns.map((column,i)=>{
      if(column.sort !== undefined && column.sort !== null){
        
        if(i === id){
          if(column.sort === "ASC"){
            column.sort = "DESC";
            asc = false;
          }else{
            column.sort = "ASC";
          }
        }else{
          column.sort = null;
        }

      }else{
        column.sort = null;
        if(i === id){
            column.sort = "ASC";
        }

      }
      return column;
    });
  
    var itemSorted = this.state.items;
    if(asc){
      itemSorted.sort((a, b) => (a[columns.filter((column,i)=> column.sort !== null)[0].name] > b[columns.filter((column,i)=> column.sort !== null)[0].name]) ? 1 : -1);
    }else{
      itemSorted.sort((a, b) => (a[columns.filter((column,i)=> column.sort !== null)[0].name] < b[columns.filter((column,i)=> column.sort !== null)[0].name]) ? 1 : -1);
    }

    this.setState({columns:columns,items:itemSorted});
  }
  
  handleClickOutside() {
      this.setState({show:false});
  }
  handleClickInside() {
    this.setState({show:true});
  } 


  // BUILDING METHOD
  componentDidMount = () =>{
    
    this.setState({
      items:this.props.listItem,
      columns:this.props.config.columns,
      selectedItemIds:this.props.selectedItemIds !== undefined?this.props.selectedItemIds:[]
    });
  }

  buildSelectedContent = () =>{
      var selectedList = null;
      var config = this.props.config;
      var itemList = this.props.listItem;
      var columns = this.state.columns;
      selectedList = this.state.selectedItemIds.map((id)=>{
        var item = itemList.find(element=>element[config.id] ===id);
        return (<div className="tag" key={item[config.id]}>{item[columns[0].name]}</div>)
      });
      return (selectedList);
  }

  onShowContent = () =>{
    this.setState({show:true,term:""});
  }

  buildValueContent = ()=>{
    var ids = this.state.selectedItemIds;
    if(ids.length>0 && !this.props.config.multiple &&  this.state.items.length>0){
      var selectedItem = this.state.items.filter(item => item.ARCS ===ids[0])[0];
      if(selectedItem !== undefined){
        if(typeof(selectedItem.WORDING) ==="string"){
          return selectedItem.CODE +" - "+selectedItem.WORDING;
        }else{
          return selectedItem.CODE +" - "+ selectedItem.WORDING[this.props.language];
        } 
      }
      
    }else{
      return this.state.term;
    }

    
  }


  buildHeaderContent = ()=>{
    var columns = this.state.columns;
    var ths = null;
    if(columns !== undefined){
      ths = columns.map((column,i)=>{
        return <th key={i} className={column.type}><div className="thWrapper combobox"><div>{column.name}</div></div></th>
      });
    }
    

    return(<thead>
      <tr>
        {ths}
      </tr>
    </thead>)
  }
  buildListContent = ()=>{
    var tds = null;
    var trs = null;
    var columns = this.props.config.columns;
    var config = this.props.config;
    var selecteds = this.state.selectedItemIds;
    var term = this.state.term;
    trs = this.state.items !== null?this.state.items.filter(item=>{
      let pattern = new RegExp(term.toUpperCase());
      return JSON.stringify(item).toUpperCase().match(pattern);
    }).map((item,i)=>{
      if(columns !== undefined){
        tds = columns.map((column,j)=>{
        return <td key={j} className={column.type} title={column.name}>{typeof(item[column.name]) ==="string"?item[column.name]:item[column.name][this.props.language]}</td>
        });
      }
      if(selecteds.filter(id=>id === item[config.id]).length > 0){
        return(<tr key={i} onClick={this.selectItem.bind(this, item[config.id])} className={config.isSelectable?"selectable active":"active"}>{tds}</tr>);
      }else{
        return(<tr key={i} onClick={this.selectItem.bind(this, item[config.id])} className={config.isSelectable?"selectable":""}>{tds}</tr>);
      }
      
    }):null;
    

    return(<tbody>
      {trs}
    </tbody>)
  }
  
  render() {
      var buildList = this.buildListContent();
      var buildHeader = this.buildHeaderContent();
      var selectedContent = this.props.config.multiple?this.buildSelectedContent():null;
      var value = this.buildValueContent();
      return (
          <div className="combobox-wrapper" ref={this.wrapperRef}>
              {this.state.show?<div className="overlay" onClick={this.handleClickOutside.bind(this)}></div>:null}
              <div className="searchbar" >
                {selectedContent}
                <div className="line">
                  <input type="text" value={value} onChange={this.onTermUpdate.bind(this,false)} onClick={this.handleClickInside.bind(this)}/>
                  <FontAwesomeIcon onClick={this.onShowContent.bind()} icon={this.state.term.length > 0?"times":"caret-down"}/>
                  
                </div>
              </div>
              <div className={this.state.show?"combobox-content show":"combobox-content"}>
                <table>
                  {buildHeader}
                  {buildList}
                </table>
              </div>
              
          </div>
      );
  }
}

const mapStateToProps = (state) => {    
  return {  
    language:state.appReducer.language,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(ComboBox);
  